import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class HealthService {
  private readonly http = inject(HttpClient);

  public check(apiUrl: string, timeoutMs = 8000): Observable<boolean> {
    return this.http.get(`${apiUrl}/health/live`).pipe(
      // delay(9000),
      timeout(timeoutMs),
      map(() => true),
      catchError(() => of(false)),
    );
  }
}
